var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49.9998,
    r: 50,
    fill: "#B9F3E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1746 28.01L62.6677 32.705L67.9996 33.3529L64.0871 36.8789L64.8696 42.095L60.1746 39.1606L55.4796 42.095L56.2621 36.8789L52.3496 33.3529L57.8271 32.705L60.1746 28.01Z",
    fill: "#59595C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.732 45.6147L56.6991 44.8353C56.1554 46.9296 55.0032 48.8159 53.388 50.2557C51.7728 51.6955 49.7671 52.6243 47.6243 52.9247C45.4815 53.2251 43.2978 52.8837 41.3489 51.9436C39.4001 51.0035 37.7736 49.5068 36.6749 47.6428C35.5762 45.7787 35.0547 43.6308 35.1762 41.4704C35.2977 39.3101 36.0568 37.2342 37.3576 35.5051C38.6583 33.776 40.4424 32.4711 42.4844 31.7555C44.5264 31.0398 46.7346 30.9455 48.8302 31.4843L49.6112 28.4529C46.5563 27.6582 43.3229 27.914 40.4309 29.179C37.5389 30.4441 35.1563 32.6449 33.6663 35.4276C32.1762 38.2104 31.6652 41.4133 32.2154 44.5216C32.7656 47.6298 34.3451 50.4627 36.6999 52.5648V71.83L46.0899 65.57L55.4799 71.83V52.593C57.5585 50.7405 59.0387 48.3112 59.732 45.6147ZM52.3499 65.9816L46.0899 61.8077L39.8299 65.9816V54.6932C41.7721 55.6689 43.9153 56.1778 46.0888 56.1795C48.2623 56.1811 50.4062 55.6754 52.3499 54.7026V65.9816Z",
    fill: "#59595C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/qa.501691622e0f248249ee9ead58c66269.svg";
export { ForwardRef as ReactComponent };